import {Botao, BotaoExcluir, BotaoImprimir, BotaoPesquisar, PaginaLogada, SelectFetch} from "../../componentes";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {CirastServico, UsuarioServico} from "../../servicos";
import {
  exibirMensagemAlerta,
  exibirMensagemErro,
  exibirMensagemPergunta,
  exibirMensagemSucesso,
  formatarData,
  xfetch
} from "../../util";
import {Card} from "../../componentes/card/Card";
import {BOTAO, ICONE} from "../../config/constantes/constantes";

export default function ListarConsultasCirastAdm() {
  const navegacao = useNavigate()
  const [consultas, setConsultas] = useState([])
  const [isCarregando, setIsCarregando] = useState(false)
  const [filtro, setFiltro] = useState('')
  const [filtros, setFiltros] = useState({
    dtInicial: '',
    dtFinal: '',
    idClinica: -1
  })

  function buscarConsultas() {
    setIsCarregando(true)
    CirastServico.listarConsultasCirastAdm()
      .then(res => res.json())
      .then(dados => setConsultas(dados))
      .catch(() => exibirMensagemErro("Erro ao buscar consultas"))
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    buscarConsultas()
  }, [])

  function imprimir(id) {
    // setIsCarregando(true)
    window.open('/impressaoCirast/'+id)
  }

  async function mostrarEmail(idCadastrante) {

    const usuario = await UsuarioServico.getUsuario(idCadastrante)
    console.log(usuario)
    return usuario?.email
  }

  function removerConsulta(id) {
    let res = window.confirm("Deseja realmente remover a consulta?")
    if (res) {
      setIsCarregando(true)
      CirastServico.removerConsulta(id)
        .then(res => res.json())
        .then(dados => exibirMensagemSucesso("Consulta removida com sucesso") & buscarConsultas())
        .catch(() => exibirMensagemErro("Erro ao excluir a consulta"))
        .finally(() => setIsCarregando(false))
      buscarConsultas()
    }
    return;
  }

  function inativarConsulta(id) {
    let res = window.confirm("Deseja realmente inativar a consulta?")
    if (res) {
      setIsCarregando(true)
      CirastServico.inativarConsulta(id)
        .then(res => res.json())
        .then(dados => exibirMensagemSucesso("Consulta inativada com sucesso!") & buscarConsultas())
        .catch(() => exibirMensagemErro("Erro ao inativar a consulta"))
        .finally(() => setIsCarregando(false))
    }
  }

  function detalheAtendimento(id) {
    navegacao(`/detalheAtendimento/${id}`)
  }

  function buscarComFiltro() {
    if (filtros.dtInicial && filtros.dtFinal) {
      setIsCarregando(true)
      CirastServico.listarConsultasCirastAdm(filtros)
        .then(res => res.json())
        .then(dados => setConsultas(dados))
        .catch(() => exibirMensagemErro("Erro ao buscar consultas"))
        .finally(() => setIsCarregando(false))

    }
  }

  return (
    <PaginaLogada titulo="Listagem de consultas ADM" isCarregando={isCarregando}>
      <div className="row">
        <Card className="col-lg-12">
          <div className="row">
            <div className="col-lg-3 mb-5">
              <label>Filtro:</label>
              <input className="form-control" placeholder="Buscar" onChange={(e) => setFiltro(e.target.value)}/>
            </div>
            <div className="col-lg-3 mb-5">
              <label>Clinica:</label>
              <SelectFetch
                handleChange={(v) => setFiltros({...filtros, idClinica: v.value})}
                url='/cirast/clinica'
                setIsCarregando={setIsCarregando}
                placeholder='Selecione a clinica' />
              </div>
            <div className="col-lg-2 mb-5">
              <label>Data inicio</label>
              <input
                className="form-control" type="date"
                onChange={(e) => setFiltros({...filtros, dtInicial: e.target.value})}/>
            </div>
            <div className="col-lg-2 mb-5">
              <label>Data fim</label>
              <input
                className="form-control"
                type="date"
                onChange={(e) => setFiltros({...filtros, dtFinal: e.target.value})}/>
            </div>
            <div className="col-lg-2 mt-4">
              <BotaoPesquisar onClick={buscarComFiltro} className="mt-2"/>
            </div>
          </div>
          <div className="col-lg-12">
            <table className="table table-stripped table-hover table-bordered">
              <thead>
              <tr>
                <th>Paciente</th>
                <th>Tipo</th>
                <th>Criador</th>
                <th>Clinica</th>
                <th>Inicio validade</th>
                <th>Atendimentos</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
              </thead>
              <tbody>
              {consultas.filter(c => c.consultaCirast.paciente.indexOf(filtro.toUpperCase()) > -1).map((v, k) => {
                return (
                  <tr key={k}>
                    <td>{v.consultaCirast.paciente}</td>
                    <td>{v.consultaCirast.tpAntedimento}</td>
                    <td>{v.cadastrante}</td>
                    <td>{v.consultaCirast.clinicaCirast.nome}</td>
                    <td>{formatarData(v.consultaCirast.dataInicioValidade)}</td>
                    <td>{v.consultaCirast.qtdExecutado}/{v.consultaCirast.qtdSolicitado}</td>
                    <td>
                      <span className={`badge rounded-pill ${isValidoAtendimento(v.consultaCirast) ? 'bg-success' : 'bg-danger'}`} title="Tooltip on top">
                        {isValidoAtendimento(v.consultaCirast) ? 'válido' : 'inválido'}
                      </span>
                    </td>
                    <td>
                      <BotaoImprimir onClick={() => imprimir(v.consultaCirast.id)} margem={1} />
                      <BotaoExcluir onClick={() => removerConsulta(v.consultaCirast.id)} margem={1} />
                      <Botao
                        className={!isValidoAtendimento(v.consultaCirast) ? 'd-none' : ''}
                        cor={BOTAO.COR.ALERTA}
                        icone={ICONE.TIPO.INFO}
                        onClick={() => inativarConsulta(v.consultaCirast.id)}
                        margem={1} >
                        Inativar
                      </Botao>
                      <Botao icone={ICONE.TIPO.INFO} onClick={() => detalheAtendimento(v.consultaCirast.id)} margem={1}></Botao>
                    </td>
                  </tr>
                )
              })}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </PaginaLogada>
  )

  function isValidoAtendimento(consulta) {

    return consulta.ativo
  }
}